/* ImportAction.js */

"use strict";
const ImportScreenComponent = require("./ImportScreenComponent");
const ImportSummaryComponent = require("./ImportSummaryComponent");

class ImportAction {
    constructor(
        logger,
        gameEditor,
        modalUserFeedback,
        SiteEntity,
        CustomFields,
        userSession,
        activityMonitor,
        steveIo,
        activeView
    ) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._userSession = userSession;
        this._siteEntity = SiteEntity;
        this._customFieldsEntity = CustomFields;
        this._modalUserFeedback = modalUserFeedback;
        this._steveIo = steveIo;
        this._activeView = activeView;
        this._activityMonitor = activityMonitor;
        this.run = this.run.bind(this);
    }
    run() {
        let importScreenComponent = new ImportScreenComponent(
            this,
            this._logger,
            this._customFieldsEntity,
            this._userSession,
            this._steveIo
        );

        return this._modalUserFeedback
            .displayCustom(importScreenComponent, {dontHide: true})
            .then((result) => {
                this._activityMonitor.stopPolling();
                this._modalUserFeedback.displayLoading({
                    message: "Importing your file... This could take a moment",
                });
                const showProgFunc = (prog) => {
                    this._modalUserFeedback.showLoadingProgress(
                        `${prog.createCnt} of ${prog.targetCount}`
                    );
                };

                let workTarget = {};
                // let workTarget = {
                //     category: 'entity',
                //     entityType: 'Site',
                //     method: 'single',
                //     id: this.id,
                // };
                let workInput = {
                    sites: result.importData,
                };
                return this._siteEntity.runImportSitesWork(
                    this._userSession.activeOrganization.id,
                    workTarget,
                    workInput,
                    {launchAndForget: false},
                    showProgFunc
                );
            })
            .then((result) => {
                this._activityMonitor.startPolling();
                if (result.errorMsg) {
                    let err = new Error(result.errorMsg);
                    err.errorCode = "CaptureError";
                    err.errorMsg = result.errorMsg;
                    throw err;
                }
                if (
                    this._activeView &&
                    this._activeView.pagingFeed &&
                    this._activeView.pagingFeed.feedUpdate
                ) {
                    this._activeView.pagingFeed.feedUpdate();
                }
                return this._modalUserFeedback.displayCustom(
                    new ImportSummaryComponent(result, this._logger)
                );
            })
            .catch((err) => {
                this._activityMonitor.startPolling();
                if (err.userRejected) {
                    this._logger.warn({error: err}, "ImportAction.run() - User Canceled.");
                    return this._modalUserFeedback.hideDisplayed();
                } else {
                    this._logger.warn({error: err}, "ImportAction.run() - Error");
                    return this._modalUserFeedback.displayError(err).catch(() => {
                        return Promise.resolve();
                    });
                }
            });
    }
}

module.exports = ImportAction;

ImportAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "$teve.entities.Site",
    "$teve.entities.CustomFields",
    "$teve.userSession",
    "$teve.activityMonitor",
    "$teve.io",
    "gameEditor.activeView",
];

ImportAction.$displayDetails = {
    type: "Action",
    name: "ImportAction",
    icon: "configdrift.import_devices",
    shown: true,
    title: "Import sites",
    order: 11,
};
